import { useEffect, useState } from "react";

// Matches the modal's narrow breakpoint in global.css. Used wherever
// component layout needs to diverge between phones and tablets+ in a
// way CSS alone can't express (e.g. rendering a child in a different
// place in the tree).
const NARROW_QUERY = "(max-width: 719px)";

export function useIsNarrow(): boolean {
  const [isNarrow, setIsNarrow] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(NARROW_QUERY).matches;
  });
  useEffect(() => {
    const mq = window.matchMedia(NARROW_QUERY);
    const onChange = (e: MediaQueryListEvent) => setIsNarrow(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return isNarrow;
}
